<template>
  <div v-editable="blok" class="flex flex-wrap clamp-gap-4-6">
    <SbElementSocialMediaButton
      v-for="link in config?.socialMediaButtons"
      :key="link._uid"
      :blok="link"
      size="lg"
    />
  </div>
</template>

<script setup lang="ts">
import useConfig from '@/composables/useConfig';
import { RichtextSocialMediaButtonsStoryblok } from '@/types';

const { config } = useConfig();

interface Props {
  blok: RichtextSocialMediaButtonsStoryblok;
}
defineProps<Props>();
</script>
